export default function Navbar() {
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 h-20 flex items-center bg-background-50/90 backdrop-blur-sm">
      <div className="w-full px-10 flex items-center justify-between">
        <h1 className="text-base font-semibold text-foreground-900 tracking-tight font-heading">
          VA Soft Labs LLC
        </h1>
      </div>
    </nav>
  );
}